import React from 'react'
import { dateToLocal } from '@auteco/utils/dateToLocal'
import { Dialog, DialogContent, IconButton, Typography } from '@material-ui/core'
import FiberManualRecordIcon from '@material-ui/icons/FiberManualRecord';
import ClearIcon from '@material-ui/icons/Clear';
import { useStyles } from './styles'

const DialogFiles = ({ info }) => {
    const { xml, html, state, open, onClose } = info

    const classes = useStyles()

    const formatBooleanState = ({ value }) => value ? 'Válido' : 'Inconsistente'

    return (
        <Dialog open={open} onClose={onClose}>
            <DialogContent className={classes.dialogContent}>
                <IconButton className={classes.iconButton} onClick={onClose}>
                    <ClearIcon />
                </IconButton>
                <div className={classes.container}>
                    <Typography className={classes.title}>Facturación electrónica</Typography>
                    <Typography className={classes.title}>Página DIAN</Typography>
                    <div className={classes.fileContainer}>
                        <Typography><span className={classes.fileTitle}>Chasis:</span> {xml?.chasis}</Typography>
                        <Typography className={classes.fileShort}><span className={classes.fileTitle}>Cufe: </span> {html?.cufe}</Typography>
                        <Typography><span className={classes.fileTitle}>Fecha emisión:</span> {dateToLocal(xml?.fecha_emision).formattedDateAndHour}</Typography>
                        <Typography><span className={classes.fileTitle}>Nombre emisor:</span> {xml?.emisor.nombre}</Typography>
                        <Typography><span className={classes.fileTitle}>NIT emisor:</span> {xml?.emisor.nit}</Typography>
                        <Typography><span className={classes.fileTitle}>Nombre receptor:</span> {xml?.receptor.nombre}</Typography>
                        <Typography><span className={classes.fileTitle}>NIT receptor:</span> {xml?.receptor.nit}</Typography>
                        <Typography><span className={classes.fileTitle}>Folio:</span> {xml?.folio}</Typography>
                        <Typography><span className={classes.fileTitle}>Iva:</span> {xml?.iva}</Typography>
                        <Typography><span className={classes.fileTitle}>Serie:</span> {xml?.serie}</Typography>
                        <Typography><span className={classes.fileTitle}>Total:</span> {xml?.total.toLocaleString('es-ES')}</Typography>
                    </div>
                    <div className={classes.fileContainer}>
                        <Typography><span className={classes.fileTitle}>Chasis:</span> {html?.chasis}</Typography>
                        <Typography className={classes.fileShort}><span className={classes.fileTitle}>Cufe: </span>{html?.cufe}</Typography>
                        <Typography><span className={classes.fileTitle}>Fecha emisión:</span> {dateToLocal(html?.fecha_emision).formattedDateAndHour}</Typography>
                        <Typography><span className={classes.fileTitle}>Nombre emisor:</span> {html?.emisor.nombre}</Typography>
                        <Typography><span className={classes.fileTitle}>NIT emisor:</span> {html?.emisor.nit}</Typography>
                        <Typography><span className={classes.fileTitle}>Nombre receptor:</span> {html?.receptor.nombre}</Typography>
                        <Typography><span className={classes.fileTitle}>NIT receptor:</span> {html?.receptor.nit}</Typography>
                        <Typography><span className={classes.fileTitle}>Folio:</span> {html?.folio}</Typography>
                        <Typography><span className={classes.fileTitle}>Iva:</span> {html?.iva}</Typography>
                        <Typography><span className={classes.fileTitle}>Serie: </span>{html?.serie}</Typography>
                        <Typography><span className={classes.fileTitle}>Total:</span> {html?.total.toLocaleString('es-ES')}</Typography>
                    </div>
                </div>
                <div className={classes.stateContainer}>
                    <FiberManualRecordIcon style={{ color: state ? 'green' : 'red' }} />
                    <Typography><span className={classes.fileTitle}>Estado:</span> {formatBooleanState({ value: state })}</Typography>
                </div>
            </DialogContent>
        </Dialog>
    )
}

export { DialogFiles }